// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContributionBatch } from './contribution-batch';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class GivingAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  batchId?: number;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  filename?: string;
  name?: string;
  type?: string;
  batch!: ContributionBatch;
}

